import { Suspense } from 'react';
import {
  VenueRecipientGroups,
  VenueReportHistory,
  VenueReportMailings,
} from '@features';
import { Skeleton, Stack } from '@mantine/core';

export const VenueDetailsReportsPage: React.FC = () => {
  return (
    <Stack py="md" gap="md">
      <Suspense fallback={<Skeleton height={200} />}>
        <VenueReportMailings />
      </Suspense>
      <Suspense fallback={<Skeleton height={200} />}>
        <VenueRecipientGroups />
      </Suspense>
      <Suspense fallback={<Skeleton height={400} />}>
        <VenueReportHistory />
      </Suspense>
    </Stack>
  );
};
